export const AlertMessage = ({messages}) => {
  const isArray = Array.isArray(messages)

  if (!isArray) return messages

  return (
    <div>
      {messages.map((message, index) => (
        <div key={index}>{message}</div>
      ))}
    </div>
  )
}
